import type { FC } from 'react';
import React from 'react';
import AddRounded from '@mui/icons-material/AddRounded';
import DeleteRounded from '@mui/icons-material/DeleteRounded';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import InfoRounded from '@mui/icons-material/InfoRounded';
import ShareRounded from '@mui/icons-material/ShareRounded';
import { Button, IconButton } from '@mui/material';

import type { Report } from 'src/types/report';
import type { TemplateOrReportItem } from 'src/types/workspace';

import { styles } from './index.styles';

export const LIST_DOWNLOAD_BUTTON = 'list-download-button';

interface ItemActionsProps {
  item: TemplateOrReportItem;
  isGlobal: boolean;
  canRenderContextActions: boolean;
  showActionButtons: boolean;
  openShareModal: (item: TemplateOrReportItem) => void;
  handleDelete: (item: TemplateOrReportItem) => void;
  addItem: (item: Report) => void;
  openInfoModal: (item: TemplateOrReportItem) => void;
  showShareButton: boolean;
}

const ItemActions: FC<ItemActionsProps> = ({
  item,
  isGlobal,
  canRenderContextActions,
  showActionButtons,
  openShareModal,
  handleDelete,
  addItem,
  openInfoModal,
  showShareButton,
}) => {
  const isReport = 'report_type' in item;
  const actionButtons = showActionButtons && canRenderContextActions && (
    <>
      <IconButton
        color="primary"
        data-test-id="workspace-custom-list-share"
        onClick={() => openShareModal(item)}
        sx={styles.button}
      >
        <ShareRounded />
      </IconButton>
      <IconButton
        color="primary"
        data-test-id="workspace-custom-list-delete"
        onClick={() => handleDelete(item)}
        sx={styles.button}
      >
        <DeleteRounded />
      </IconButton>
    </>
  );

  const shareButtons = showShareButton && (
    <>
      {isReport && (
        <IconButton
          color="primary"
          onClick={() => addItem(item)}
          sx={styles.button}
        >
          <AddRounded />
        </IconButton>
      )}
      {isReport && item.file && (
        <Button
          variant="squareCta"
          color="primary"
          data-test-id={LIST_DOWNLOAD_BUTTON}
          href={item.file}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => {
            event.stopPropagation();
          }}
          download
        >
          <DownloadRounded />
        </Button>
      )}
    </>
  );

  return (
    <>
      <IconButton
        color="primary"
        size="small"
        onClick={() => openInfoModal(item)}
        sx={styles.button}
      >
        <InfoRounded />
      </IconButton>

      {!isGlobal && (
        <>
          {actionButtons}
          {shareButtons}
        </>
      )}
    </>
  );
};

export default ItemActions;
